export const AlbumProps = (album) => {
	return {
		albumId:  album.id,
		title:    album.name,
		subtitle: album.subtitle,
		type:     album.type,
	};
};
